import InternalTransferForm from '@withdrawals/views/InternalTransferForm'

const LinkedAccountsTransfer = () => <InternalTransferForm useSubAccounts={true} />
export default LinkedAccountsTransfer
